import AppConstants from '../config/app.constants';

let DenominationService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/denomination`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data, branchId) => {
        return $http
            .post(AppConstants.api + `/denomination/create`, {data, branchId})
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/denomination/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data, branchId) => {
        return $http
            .post(AppConstants.api + `/denomination/${id}`, {data, branchId})
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/denomination/${id}`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let denominationsPromise = null;

    let getName = (id) => {
        if (!denominationsPromise) {
            denominationsPromise = all(null, 0, 1000).then(res => res.results);
        }
        return denominationsPromise.then(denominationsCache => {
            if (denominationsCache) {
                let denom = denominationsCache.find(d => d.id === id);
                return denom ? denom.name : id;
            }
            return id;
        }).catch(err => {
            return id;
        });
    };

    return {
        all,
        create,
        get,
        update,
        remove,
        getName
    };

};

DenominationService.$inject = ['$http', '$q']

export default DenominationService;


// WEBPACK FOOTER //
// ./client/app/services/denomination.service.js